import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Card as SCCard } from '@keytrade/components-card';

import { Button } from '@keytrade/components-button';
import { mediaQuery } from '@/utils/helpers';
import Image from '@/components/Image';

const { list: colors } = config.colors;
const { getFont } = config.fonts;

const CustomLink = styled.a`
  display: inline-block;
  color: ${colors.BlueDawn};
  text-decoration: none;
  transition: color 180ms ease-in-out;

  &:hover {
    // Not present in old colors
    color: #006480;
  }
`;

export const BlockWrapper = styled.div`
  display: flex;

  > * {
    flex-grow: 1;
    text-align: start;
  }
`;

export const BlockContent = styled.div`
  text-align: center;
  margin-top: -80px;

  ${mediaQuery.md(`
    margin-top: -130px;
  `)}
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2.4rem;
  padding: 0;
  list-style: none;

  ${mediaQuery.md(`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  `)}
`;

export const Card = styled(SCCard)`
  display: flex;
  flex-direction: column;
  border-radius: 2.4rem;
  overflow: hidden;
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  width: 100%;
  overflow: hidden;
  font-size: 0;
  min-height: 236px;

  ${mediaQuery.md(`
    height: 260px;
  `)}
`;

export const ImageContent = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 32px;
`;

export const ContactContainer = styled.section`
  padding-top: 0 !important;
  padding-bottom: 11.2rem;
  position: relative;
`;

export const PhoneNumber = styled(CustomLink)`
  font-size: 2.4rem;
  font-family: ${({ theme }) => getFont(theme, 'semiBold')};
`;

export const SocialProviderWrapper = styled.ul`
  display: flex;
  gap: 1.6rem;
  padding: 0;
  margin: 0.8rem 0 0;
`;

export const SocialLinkWrapper = styled.li`
  list-style-type: none;
`;

export const SocialLink = styled.a`
  // Since icon are below 36px wide / tall this add
  // enable more invisible clicking area for the user
  display: inline-block;
  padding: 0.8rem;
  margin: -0.8rem;

  &:hover svg path {
    // Not present in old colors
    stroke: #006480;
  }
`;

export const AdditionalTextWrapper = styled.div`
  margin-top: 1.6rem;
`;

export const AvailabilityWrapper = styled.div`
  margin-top: 2.4rem;
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  background: ${colors.GreyWhite};
`;

export const AvailabilityTitle = styled.h3`
  color: ${colors.BlueDark};
  font-family: Averta;
  font-size: 16px;
  margin-bottom: 2.4rem;
`;

export const AvailabilityText = styled.div`
  & * {
    color: ${colors.BlueDark};
    font-family: Averta;
    font-size: 14px;
    line-height: 1.6;
  }
`;

export const HorizontalSeparator = styled.hr`
  width: 100%;
  height: 1px;
  background-color: ${colors.BlueLight};
  border: none;
  margin: 2.4rem 0;
`;

export const ChatBotLink = styled(CustomLink)`
  font-size: 1.8rem;
  line-height: 2.8rem;
  font-weight: 600;
`;

export const FaqsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 0;
  margin: 1.6rem 0 0;
`;

export const FaqItemWrapper = styled.li`
  list-style-type: none;
`;

export const FaqItem = styled(CustomLink)`
  font-size: 1.6rem;
  line-height: 2.4rem;
`;

export const FormLink = styled(Button)`
  background-color: ${colors.BlueDawn};
  border-color: ${colors.BlueDawn};
  transition: background-color 180ms ease-in-out, border-color 180ms ease-in-out;

  &:hover {
    // Not present in old colors
    background-color: #006480;
    border-color: #006480;
  }
`;

export const EmailLink = styled(CustomLink)`
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: 600;
  margin-top: 0.8rem;
`;
